import Home from '@/pages/Home.vue';
import Login from '@/pages/Login.vue';
import ForgotPassword from '@/pages/ForgotPassword.vue';
import ResetPassword from '@/pages/ResetPassword.vue';
import guest from '@/middleware/guest';

export default [
    {
        path: '/home',
        component: Home,
    },
    {
        path: '/login',
        name: 'admin.login',
        component: Login,
        meta: { layout: 'Login', middleware: [guest] }
    },
    {
        path: '/forgot-password',
        name: 'auth.forgot',
        component: ForgotPassword,
        meta: { layout: 'Login', middleware: [guest] }
    },
    // The link in the reset email. No guest guard: it must work even in a browser still signed in.
    {
        path: '/reset-password',
        name: 'auth.reset',
        component: ResetPassword,
        meta: { layout: 'Login' }
    },
    // Accounts are opened by an administrator; the old pages lead to the new ones.
    { path: '/register', redirect: { name: 'admin.login' } },
    { path: '/reset', redirect: { name: 'auth.forgot' } },
    { path: '/reseting', redirect: { name: 'auth.forgot' } },
    { path: '/newpage', redirect: { name: 'auth.forgot' } },
];
